module.exports = {"app_url":"https://app.quickepay.co.mz/auth","app_api":"https://api.quickepay.co.mz","blog_api":"https://api.quickepay.co.mz/blog"}


//////////////////
// WEBPACK FOOTER
// ./src/database/settings.json
// module id = C/bi
// module chunks = 0